export const dateTimeFormatOptions = {
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
} as unknown as Intl.DateTimeFormatOptions;

export const dateTimeFormatEsAR = new Intl.DateTimeFormat(
  'es-AR',
  dateTimeFormatOptions
);
